<template>
	<div class="claim-apply">
		<!-- 固定步骤条 -->
		<div class="fixed-steps">
			<el-steps :active="active" simple align-center>
				<el-step title="填写资料" icon="el-icon-edit"/>
				<el-step title="上传资料" icon="el-icon-upload"/>
				<el-step title="提交完成" icon="el-icon-success"/>
			</el-steps>
		</div>

		<!-- 内容区域 -->
		<div class="content-area">
			<!-- 测试数据按钮 -->
			<div v-if="active === 1" class="test-buttons">
				<el-button type="warning" size="small" @click="fillTestData">填充测试数据</el-button>
				<el-button type="info" size="small" @click="clearFormData">清空表单</el-button>
			</div>

			<!-- 保单信息 -->
			<div v-if="orderInfo" class="order-info-card">
				<div class="card-title">保单信息</div>
				<el-descriptions :column="2" border>
					<el-descriptions-item label="保单号">{{ orderInfo.policy_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="保险产品">{{ orderInfo.goods_name || '-' }}</el-descriptions-item>
					<el-descriptions-item label="保险期间">
						{{ orderInfo.pln_start_date || '-' }} 至 {{ orderInfo.pln_end_date || '-' }}
					</el-descriptions-item>
					<el-descriptions-item label="保单金额">¥{{ orderInfo.amount || '0.00' }}</el-descriptions-item>
					<el-descriptions-item label="投保人" :span="2">
						{{ getApplicantName(orderInfo.applicant_info) || '-' }}
					</el-descriptions-item>
				</el-descriptions>
			</div>

			<!-- 第一步：填写资料 -->
			<div v-if="active === 1" class="step-content">
				<el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
					<div class="form-section">
						<div class="section-title">出险人信息</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="出险人姓名" prop="insurant_name">
									<el-input v-model="form.insurant_name" placeholder="请输入被保险人姓名" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="证件类型" prop="insurant_cert_type">
									<el-select v-model="form.insurant_cert_type" placeholder="请选择证件类型">
										<el-option label="身份证" value="01" />
										<el-option label="护照" value="02" />
										<el-option label="港澳居民往来内地通行证" value="03" />
										<el-option label="台湾居民往来大陆通行证" value="04" />
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="证件号码" prop="insurant_cert_no">
									<el-input v-model="form.insurant_cert_no" placeholder="请输入证件号码" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="报案人电话" prop="reporter_telephone">
									<el-input v-model="form.reporter_telephone" placeholder="请输入报案人电话" />
								</el-form-item>
							</el-col>
						</el-row>
					</div>

					<div class="form-section">
						<div class="section-title">理赔信息</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="报案人姓名" prop="reporter">
									<el-input v-model="form.reporter" placeholder="请输入报案人姓名" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="报案时间" prop="regist_time">
									<el-date-picker
										v-model="form.regist_time"
										type="datetime"
										placeholder="选择报案时间"
										value-format="yyyy-MM-dd HH:mm:ss"
										style="width: 100%;"
									/>
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-form-item label="报案地点" prop="regist_address">
							<el-input v-model="form.regist_address" placeholder="请输入报案地点" />
						</el-form-item>
						
						<el-form-item label="出险经过" prop="accident_desc">
							<el-input 
								v-model="form.accident_desc" 
								type="textarea" 
								:rows="4" 
								placeholder="请详细描述出险经过"
							/>
						</el-form-item>
					</div>

					<div class="form-section">
						<div class="section-title">理赔收款账户</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="账户名" prop="account_name">
									<el-input v-model="form.account_name" placeholder="请输入收款人名称" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="银行卡号" prop="account_code">
									<el-input v-model="form.account_code" placeholder="请输入开户行账号" />
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="开户行" prop="bank_name_cn">
									<el-input v-model="form.bank_name_cn" placeholder="请输入开户行名称" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="银行名称" prop="formal_bank_bame_cn">
									<el-input v-model="form.formal_bank_bame_cn" placeholder="请输入银行名称" />
								</el-form-item>
							</el-col>
						</el-row>
						
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="开户省份" prop="deposit_bank_province">
									<el-input v-model="form.deposit_bank_province" placeholder="请输入开户行所在省份" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="开户城市" prop="deposit_bank_city">
									<el-input v-model="form.deposit_bank_city" placeholder="请输入开户行所在城市" />
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</el-form>
			</div>

			<!-- 第二步：上传资料 -->
			<div v-if="active === 2" class="step-content">
				<!-- 测试文件按钮 -->
				<div class="test-buttons">
					<el-button type="warning" size="small" @click="fillTestFileData">填充测试文件数据</el-button>
				</div>

				<div class="upload-section">
					<div class="section-title">门诊病历</div>
					<page-images :limit="5" v-model="form.outpatient_record_file" />
				</div>
				
				<div class="upload-section">
					<div class="section-title">医疗费用发票</div>
					<page-images :limit="5" v-model="form.medical_invoice_file" />
				</div>
				
				<div class="upload-section">
					<div class="section-title">费用明细清单</div>
					<page-images :limit="5" v-model="form.cost_detail_file" />
				</div>
				
				<div class="upload-section">
					<div class="section-title">检查报告</div>
					<page-images :limit="5" v-model="form.check_report_file" />
				</div>
			</div>

			<!-- 第三步：提交完成 -->
			<div v-if="active === 3" class="step-content result-content">
				<el-result icon="success" title="理赔申请提交成功" subTitle="等待审核">
					<template slot="extra">
						<el-button type="primary" @click="$emit('success')">返回订单列表</el-button>
					</template>
				</el-result>
			</div>
		</div>

		<!-- 底部操作按钮 -->
		<div class="footer-actions" v-if="active !== 3">
			<el-button @click="handleCancel">取消</el-button>
			<el-button v-if="active === 1" type="primary" @click="nextStep">下一步</el-button>
			<el-button v-if="active === 2" @click="active = 1">上一步</el-button>
			<el-button v-if="active === 2" type="primary" @click="submitClaim">提交申请</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ClaimApply',
	props: {
		orderId: {
			type: [String, Number],
			required: true
		}
	},
	data() {
		return {
			active: 1,
			orderInfo: null,
			form: {
				order_id: this.orderId,
				insurant_name: '',
				insurant_cert_type: '01',
				insurant_cert_no: '',
				reporter: '',
				reporter_telephone: '',
				regist_time: this.getCurrentTime(),
				regist_address: '',
				accident_desc: '',
				account_name: '',
				account_code: '',
				bank_name_cn: '',
				formal_bank_bame_cn: '',
				deposit_bank_province: '',
				deposit_bank_city: '',
				outpatient_record_file: '',
				medical_invoice_file: '',
				cost_detail_file: '',
				check_report_file: '',
				file_list: '',
				settle_status: 0,
			},
			rules: {
				insurant_name: [{ required: true, message: '请输入出险人姓名', trigger: 'blur' }],
				insurant_cert_type: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
				insurant_cert_no: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
				reporter: [{ required: true, message: '请输入报案人姓名', trigger: 'blur' }],
				reporter_telephone: [
					{ required: true, message: '请输入报案人电话', trigger: 'blur' },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
				],
				regist_time: [{ required: true, message: '请选择报案时间', trigger: 'change' }],
				regist_address: [{ required: true, message: '请输入报案地点', trigger: 'blur' }],
				accident_desc: [
					{ required: true, message: '请输入出险经过', trigger: 'blur' },
					{ min: 10, message: '出险经过至少10个字符', trigger: 'blur' }
				],
				account_name: [{ required: true, message: '请输入账户名', trigger: 'blur' }],
				account_code: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
				bank_name_cn: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
				formal_bank_bame_cn: [{ required: true, message: '请输入银行名称', trigger: 'blur' }],
				deposit_bank_province: [{ required: true, message: '请输入开户省份', trigger: 'blur' }],
				deposit_bank_city: [{ required: true, message: '请输入开户城市', trigger: 'blur' }]
			}
		}
	},
	mounted() {
		this.loadOrderInfo();
	},
	methods: {
		// 填充测试数据
		fillTestData() {
			const testData = {
				insurant_name: '张三',
				insurant_cert_type: '01',
				insurant_cert_no: '110101199001011234',
				reporter: '李四',
				reporter_telephone: '13800138000',
				regist_time: this.getCurrentTime(),
				regist_address: '北京市朝阳区建国路100号',
				accident_desc: '2024年1月15日下午3点左右，被保险人在家中不慎滑倒，导致右手腕部疼痛肿胀。立即前往北京协和医院急诊科就诊，经X光检查确诊为右手腕骨折。医生进行了石膏固定处理，并开具了相关药物。整个治疗过程持续约3小时，医疗费用共计2850元。',
				account_name: '张三',
				account_code: '6222021000001234567',
				bank_name_cn: '中国工商银行北京分行朝阳支行',
				formal_bank_bame_cn: '中国工商银行',
				deposit_bank_province: '北京市',
				deposit_bank_city: '北京市'
			};
			
			Object.keys(testData).forEach(key => {
				if (this.form.hasOwnProperty(key)) {
					this.form[key] = testData[key];
				}
			});
			
			this.$message.success('测试数据填充完成');
		},

		// 填充测试文件数据
		fillTestFileData() {
			const testFileData = {
				outpatient_record_file: 'https://example.com/images/outpatient_record.jpg',
				medical_invoice_file: 'https://example.com/images/medical_invoice.jpg',
				cost_detail_file: 'https://example.com/images/cost_detail.jpg',
				check_report_file: 'https://example.com/images/check_report.jpg'
			};
			
			Object.keys(testFileData).forEach(key => {
				if (this.form.hasOwnProperty(key)) {
					this.form[key] = testFileData[key];
				}
			});
			
			this.$message.success('测试文件数据填充完成');
		},

		// 清空表单数据
		clearFormData() {
			this.form = {
				order_id: this.orderId,
				insurant_name: '',
				insurant_cert_type: '01',
				insurant_cert_no: '',
				reporter: '',
				reporter_telephone: '',
				regist_time: this.getCurrentTime(),
				regist_address: '',
				accident_desc: '',
				account_name: '',
				account_code: '',
				bank_name_cn: '',
				formal_bank_bame_cn: '',
				deposit_bank_province: '',
				deposit_bank_city: '',
				outpatient_record_file: '',
				medical_invoice_file: '',
				cost_detail_file: '',
				check_report_file: '',
				file_list: '',
				settle_status: 0,
			};
			// 重新自动填充被保险人信息
			if (this.orderInfo && this.orderInfo.insureds && this.orderInfo.insureds.length > 0) {
				const insured = this.orderInfo.insureds[0];
				this.form.insurant_name = insured.name || '';
				this.form.insurant_cert_no = insured.id_card || '';
			}
			this.$message.success('表单数据已清空');
		},

		// 加载订单信息
		async loadOrderInfo() {
			try {
				const res = await this.$get(`app-order/${this.orderId}`);
				this.orderInfo = res.data;
				// 自动填充被保险人信息
				if (this.orderInfo.insureds && this.orderInfo.insureds.length > 0) {
					const insured = this.orderInfo.insureds[0];
					this.form.insurant_name = insured.name || '';
					this.form.insurant_cert_no = insured.id_card || '';
				}
			} catch (error) {
				console.error('加载订单信息失败:', error);
				this.$message.error('加载保单信息失败');
			}
		},

		// 获取投保人姓名
		getApplicantName(applicantInfo) {
			if (!applicantInfo) return '';
			try {
				if (typeof applicantInfo === 'string') {
					const parsed = JSON.parse(applicantInfo);
					return parsed.applicant_name || '';
				} else if (typeof applicantInfo === 'object') {
					return applicantInfo.applicant_name || '';
				}
				return '';
			} catch (error) {
				return '';
			}
		},

		// 获取当前时间
		getCurrentTime() {
			const now = new Date();
			return now.getFullYear() + '-' + 
				   String(now.getMonth() + 1).padStart(2, '0') + '-' + 
				   String(now.getDate()).padStart(2, '0') + ' ' + 
				   String(now.getHours()).padStart(2, '0') + ':' + 
				   String(now.getMinutes()).padStart(2, '0') + ':' + 
				   String(now.getSeconds()).padStart(2, '0');
		},

		// 取消操作
		handleCancel() {
			this.$emit('cancel');
		},

		// 下一步
		nextStep() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					this.active = 2;
				} else {
					this.$message.error('请完善表单信息');
				}
			});
		},

		// 提交理赔申请
		async submitClaim() {
			// 检查必传文件
			if (!this.form.outpatient_record_file) {
				this.$message.error('请上传门诊病历');
				return;
			}
			if (!this.form.medical_invoice_file) {
				this.$message.error('请上传医疗费用发票');
				return;
			}
			if (!this.form.cost_detail_file) {
				this.$message.error('请上传费用明细清单');
				return;
			}

			// 组合文件列表
			this.combineFileList();

			try {
				this.$load();
				await this.$post('app-order-claim', this.form, true);
				this.active = 3;
				this.$message.success('理赔申请提交成功');
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.$load(false);
			}
		},

		// 组合文件列表
		combineFileList() {
			const fileList = [];
			
			const files = [
				this.form.outpatient_record_file,
				this.form.medical_invoice_file,
				this.form.cost_detail_file,
				this.form.check_report_file
			];
			
			files.forEach(file => {
				if (file && file.trim() !== '') {
					fileList.push(file);
				}
			});
			
			this.form.file_list = JSON.stringify(fileList);
		}
	}
}
</script>

<style lang="scss" scoped>
.claim-apply {
	height: 100%;
	display: flex;
	flex-direction: column;
	
	.fixed-steps {
		position: sticky;
		top: 0;
		background: #fff;
		padding: 0 20px 10px;
		border-bottom: 1px solid #e8e8e8;
		z-index: 100;
	}
	
	.content-area {
		flex: 1;
		overflow-y: auto;
		padding: 20px;
	}
	
	.test-buttons {
		text-align: right;
		margin-bottom: 20px;
		
		.el-button {
			margin-left: 10px;
		}
	}
	
	.order-info-card {
		background: #f8f9fa;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 30px;
		
		.card-title {
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 15px;
			color: #333;
		}
	}
	
	.form-section {
		margin-bottom: 30px;
		
		.section-title {
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 20px;
			color: #333;
			padding-bottom: 10px;
			border-bottom: 1px solid #e8e8e8;
		}
	}
	
	.upload-section {
		margin-bottom: 30px;
		
		.section-title {
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 15px;
			color: #333;
		}
	}
	
	.result-content {
		text-align: center;
		padding: 40px 0;
	}
	
	.footer-actions {
		padding: 20px;
		border-top: 1px solid #e8e8e8;
		text-align: center;
		background: #fff;
		position: sticky;
		bottom: 0;
		
		.el-button {
			margin: 0 10px;
			min-width: 100px;
		}
	}
	
	::v-deep .el-form-item__label {
		font-weight: 500;
	}
	
	::v-deep .el-input,
	::v-deep .el-select {
		width: 100%;
	}
}
</style>